<template>
  <nav-square-button :to="{ name: $routes.MESSAGES }" :badge-count="allItemsCount" :active="active">
    <template #active>
      <i-custom-messages-filled />
    </template>
    <template #inactive>
      <i-custom-messages />
    </template>
    <span>{{ $translate("common.messages") }}</span>
  </nav-square-button>
</template>

<script>
import { mapGetters } from "pinia"

import { useUserSessionStore } from "@/store/userSession.js"

import NavSquareButton from "@/components/navs/NavSquareButton.vue"

export default {
  components: {
    NavSquareButton
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(useUserSessionStore, ["newMessagesCount", "friendRequestsCount"]),
    allItemsCount() {
      return this.newMessagesCount + this.friendRequestsCount
    }
  }
}
</script>

<style lang="scss" scoped>
.app-icon {
  width: 24px;
  height: 24px;
}

:deep(.v-badge) {
  height: 24px;
  width: 24px;
}
</style>
